import { useState } from "react";
import {
  Typography,
  TextField,
  Box,
  Grid
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { CouponTemplateFormDto } from "../../../store/models/coupon/CouponManagementDto";

interface CouponValidityStepProps {
  formData: CouponTemplateFormDto;
  updateFormData: (updates: Partial<CouponTemplateFormDto>) => void;
  readOnly?: boolean;
}

const CouponValidityStep = ({
  formData,
  updateFormData,
  readOnly = false
}: CouponValidityStepProps) => {
  const { t } = useTranslation();
  const [touchedFields, setTouchedFields] = useState<{[key: string]: boolean}>({});

  const handleFieldTouch = (fieldName: string) => {
    setTouchedFields(prev => ({ ...prev, [fieldName]: true }));
  };

  const getExpirationDaysError = () => {
    const isFieldTouched = touchedFields.validityPeriodDays;
    const hasInvalidValue = !formData.validityPeriodDays || formData.validityPeriodDays <= 0;

    if (isFieldTouched && hasInvalidValue) {
      return t("coupon.form.errors.expirationDaysRequired");
    }
    return "";
  };

  const hasExpirationDaysError = () => {
    const isFieldTouched = touchedFields.validityPeriodDays;
    const hasInvalidValue = !formData.validityPeriodDays || formData.validityPeriodDays <= 0;
    return isFieldTouched && hasInvalidValue;
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#3859ff' }}>
        {t("coupon.form.validity")}
      </Typography>

      <Grid container spacing={3} sx={{ mt: 1 }}>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label={t("coupon.form.validityPeriodDays")}
            type="number"
            value={formData.validityPeriodDays || ''}
            onChange={(e) => updateFormData({ validityPeriodDays: parseInt(e.target.value) || 0 })}
            onBlur={() => handleFieldTouch('validityPeriodDays')}
            placeholder="e.g., 30"
            required
            error={hasExpirationDaysError()}
            helperText={getExpirationDaysError()}
            sx={{ backgroundColor: 'white' }}
            inputProps={{ min: 1 }}
            disabled={readOnly}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default CouponValidityStep;
